import React, { useState } from 'react';
import * as moment from "moment";
import { MobileViewWrapper, TableWrapper } from './orderReportsStyled'
import { SearchWrapper, SelectWrapper } from "web/pages/private/Admin/DashBoard/dashBoardStyled";
import CsvDownloader from "react-csv-downloader";
import FilterIcon from 'web/assets/svg/MyOrderReportFilterIcon'
import { AiOutlineSearch } from "react-icons/ai";
import DownArrow from 'web/assets/svg/AccordionDownArrow'
import UpArrow from 'web/assets/svg/AccordionUpArrow'
import FilterModal from './FilterModal';
import Pagination from "@material-ui/lab/Pagination";
import Spinner from "web/components/Spinner";
import { greenButton, requestTypeList, selectStyle } from './Constants'

const MobileViewAccordion = (props) => {
    const { loaderVisible, tableSearch, requestTypeChangeFunction, handleSearchChange, csvExportFunction, isExporting,
        finalData, orderFilterState, handleFilterStateChange, handleStatusChange, filterCities, states,
        statusList, pageCount, page, handleChange, callFetchApi, callBack } = props
    const [filterPopUpModal, setFilterPopUpModal] = useState(false);
    const [isOpen, setIsOpen] = useState([]);

    const toggleAccordion = (index) => {
        const newIsOpen = [...isOpen];
        newIsOpen[index] = !newIsOpen[index];
        setIsOpen(newIsOpen);
    };

    function getStatus(item) {
        if (item.isClaimed && item.orderStatus === "CLAIM") {
            return `${item.orderStatus} (${item.claimDetails?.status || (item.claim?.length > 0 && item.claim[item.claim.length - 1].claimStatus)})`;
        } else if (item.isClaimed && item.orderStatus === "COMPLETE") {
            return item.orderStatus;
        } else if (item.isClaimed && item.orderStatus !== "COMPLETE" && item.orderStatus !== "CLAIM") {
            return item.orderStatus;
        } else if (item.isClaimed === null && item.orderStatus === "CLAIM") {
            return "CLAIM (PENDING)";
        } else if (item.isClaimed === null && item.orderStatus !== "CLAIM") {
            return item.orderStatus;
        } else if (item.isClaimed === false) {
            return item.orderStatus;
        }
    }

    return (
        <MobileViewWrapper>
            {loaderVisible && <Spinner />}
            <TableWrapper>
                <div>
                    <div class="community-details-header seller">
                        <div class="community-name">
                            <h4>{'My Order Report'}</h4>
                        </div>
                        <p style={{ cursor: 'pointer', fontFamily: 'latomedium', marginRight: '7px' }}
                            onClick={() => setFilterPopUpModal(true)}
                        ><FilterIcon /> Filter</p>
                    </div>
                    <div className="request-type-class" style={{ marginBottom: '15px', justifyContent: 'end' }}>
                        <p>Request Type : </p>
                        <SelectWrapper>
                            <select
                                style={selectStyle}
                                id="requestType"
                                value={orderFilterState.requestType}
                                onChange={requestTypeChangeFunction}
                            >
                                {requestTypeList.map((data, index) => {
                                    return <option value={data.value}>{data.label}</option>;
                                })}
                            </select>
                        </SelectWrapper>
                    </div>
                    <div style={{ display: 'flex' }}>
                        <SearchWrapper>
                            <input
                                style={{ border: "1px solid #69BBE0", borderRadius: "5px" }}
                                type="text"
                                placeholder='Search'
                                value={tableSearch}
                                onChange={handleSearchChange}
                            />
                            <AiOutlineSearch />
                        </SearchWrapper>
                        <div>
                            <button
                                disabled={finalData && finalData?.length === 0}
                                style={greenButton}
                                onClick={csvExportFunction}
                            >{isExporting ? 'Exporting...' : 'Export'}
                            </button>
                        </div>
                    </div>
                </div>
            </TableWrapper>
            {finalData?.map((item, index) => (
                <div key={index} className={`mobile-accordion ${isOpen[index] ? 'open' : ''}`}>
                    <div className="accordion-header" onClick={() => toggleAccordion(index)}>
                        <div className="accordion-header-left">
                            <div className="info">
                                <h6>Order ID</h6>
                                <p style={{ minWidth: '150px' }}>{item.orderId}</p>
                            </div>
                            <div className="info">
                                <h6>Status</h6>
                                <p>{item.orderStatus === 'CANCELLED' ? 'CANCELED' : item.orderStatus}</p>
                            </div>
                        </div>
                        <div className="accordion-header-right">
                            <p>{isOpen[index] ? <UpArrow /> : <DownArrow />}</p>
                        </div>
                    </div>
                    {isOpen[index] && (
                        <div className="accordion-content">
                            <div className="accordion-column">
                                <div className="info-header2">
                                    <div className="info">
                                        <h6>Invoice No</h6>
                                        <p>{item?.invoiceNumber ? item?.invoiceNumber : "NA"}</p>
                                    </div>
                                    <div className="info">
                                        <h6>Reference Number</h6>
                                        <p>{item.orderRefNumber ? item.orderRefNumber : ""}</p>
                                    </div>
                                </div>
                                <div className="info-header1">
                                    <div className="info">
                                        <h6>Other Party</h6>
                                        <p>{item.otherPartyInfo}}
                                        </p>
                                    </div>
                                </div>
                                <div className="info-header3">
                                    <div className="info">
                                        <h6>Transport Type</h6>
                                        <p>{item.transportType}</p>
                                    </div>
                                    <div className="info">
                                        <h6>Order Type</h6>
                                        <p>{item.orderType}</p>
                                    </div>
                                    <div className="info">
                                        <h6>Invoice Date</h6>
                                        <p>{item?.invoiceDate ? item?.invoiceDate : "NA"}</p>
                                    </div>
                                </div>
                                <div className="info-header3">
                                    <div className="info">
                                        <h6>Requested Date</h6>
                                        <p>{moment(item?.requestedDate).format("MM/DD/YYYY")}</p>
                                    </div>
                                    <div className="info">
                                        <h6>Payment Initiated Date</h6>
                                        <p>{item?.initiatePaymentDate ? moment(item?.initiatePaymentDate).format("MM/DD/YYYY") : 'NA'}</p>
                                    </div>
                                    <div className="info">
                                        <h6>My A/c No.</h6>
                                        <p>{`****${item?.cardInfo}`}</p>
                                    </div>
                                </div>
                                <div className="info-header3">
                                    <div className="info">
                                        <h6>Quantity</h6>
                                        <p>{item?.quantity}</p>
                                    </div>
                                    <div className="info">
                                        <h6>Total Amount</h6>
                                        <p>{item?.totalAmount == null ? '' : `$ ${item?.totalAmount?.toFixed(2)}`}</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    )}
                </div>
            ))}
            {finalData?.length === 0 && (
                <p style={{ position: "absolute", width: "100%", textAlign: "center", }}>
                    No record found
                </p>
            )}
            {finalData?.length !== 0 && (
                <div style={{ margin: '25px 0' }}>
                    <Pagination count={pageCount} page={page} onChange={handleChange} />
                </div>
            )}
            <FilterModal
                isOpen={filterPopUpModal}
                orderFilterState={orderFilterState}
                handleFilterStateChange={handleFilterStateChange}
                handleStatusChange={handleStatusChange}
                toggle={() => setFilterPopUpModal(!filterPopUpModal)}
                filterCities={filterCities}
                states={states}
                statusList={statusList}
                callBack={(type, resetValues) => {
                    if (type === 'clear') {
                        callBack(resetValues)
                    } else if (type === 'apply') {
                        setFilterPopUpModal(false)
                        callFetchApi()
                    }
                }}
            />
        </MobileViewWrapper>
    );
};

export default MobileViewAccordion;
